/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ListOfScheduleSiteChangeRequestAssignmentDto } from './listOfScheduleSiteChangeRequestAssignmentDto.schema';

export const ScheduleSiteChangeRequestDto = zod.object({
  "id": zod.string().uuid().optional(),
  "coordinatorId": zod.string().uuid().optional(),
  "coordinatorName": zod.string().optional(),
  "monthId": zod.number().optional(),
  "monthName": zod.string().optional(),
  "areaId": zod.number().optional(),
  "areaName": zod.string().optional(),
  "year": zod.number().optional(),
  "statusId": zod.number().optional(),
  "statusName": zod.string().optional(),
  "remarks": zod.string().optional(),
  "coordinatorRemarks": zod.string().optional(),
  "supervisorRemarks": zod.string().optional(),
  "dateFrom": zod.coerce.date().optional(),
  "dateTo": zod.coerce.date().optional(),
  "payload": zod.lazy(() => ListOfScheduleSiteChangeRequestAssignmentDto).optional()
});

export type ScheduleSiteChangeRequestDto = zod.input<typeof ScheduleSiteChangeRequestDto>;
export type ScheduleSiteChangeRequestDtoOutput = zod.output<typeof ScheduleSiteChangeRequestDto>;
